import React, { Component } from 'react';
import { history } from '../../helpers/history';

class SignOut extends Component {

	constructor(props) {
		super(props);
		props.signOutUser();
		window.location = "/";
	}

	render() {
  	return (
      <div>Signing you out...</div>
    )
  }
}

export default SignOut
